export const getArrayFromString = (payload: string) => {
	return payload ? payload.split(",").map(Number) : [];
};
